module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_server.574ec84b.svg";